var TorsoListView = require('backbone-torso/modules/ListView'),
    eregStaffPatientLookupResultsTemplate = require('./eregStaffPatientLookupResultsTemplate.hbs'),
    patientLookupResultListItemView = require('./EregStaffPatientLookupListItemView');

/**
 * View for displaying patient lookup results
 *
 * @class EregStaffPatientLookupResultsView
 * @constructor
 */
module.exports = TorsoListView.extend({
  className: 'patient-lookup-results',
  moduleNamespace: 'eregStaffPatientLookupFormView',
  template: eregStaffPatientLookupResultsTemplate,
  itemView: patientLookupResultListItemView,
  itemContainer: 'patient-lookup-items',

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    return {
      hasResults: !!this.collection.length
    };
  },

  /**
   * @method _dispose
   * @override
   */
  _dispose: function() {
    this.collection.dispose();
  }
});
